import { GzMaintenanceWindowSummaryWebComponent } from './component/GzMaintenanceWindowSummaryWebComponent';

export { GzMaintenanceWindowSummaryWebComponent };
